import { ReducerName } from "../state/reducers/types"
import { TableData } from "./tableData"
import { TableName } from "./types/types"

export const TablesData = new Map<TableName, TableData>()

export const initTablesData = () => {
    registerTableData(TableName.ADJUSTMENT_NOTES, true, ReducerName.ADMINISTRATION_REDUCER, 'adjustmentNotes', 'Nota de Crédito', 'AdjustmentNotes')
    registerTableData(TableName.ADMIN, false, ReducerName.SYSTEM_REDUCER, 'construfyAdminId', 'Admin', 'Admin')
    registerTableData(TableName.BRANCHES, true, ReducerName.MANAGER_REDUCER, 'branches', 'Sucursal', 'Branches')
    registerTableData(TableName.BUDGETS, true, ReducerName.SALES_REDUCER, 'budgets', 'Presupuesto', 'Budgets')
    registerTableData(TableName.CASH_FUNDS, true, ReducerName.ADMINISTRATION_REDUCER, 'cashFunds', 'Caja', 'CashFunds')
    registerTableData(TableName.CATEGORIES, true, ReducerName.PRODUCTS_REDUCER, 'categories', 'Categoría', 'Categories')
    registerTableData(TableName.CHECKS, true, ReducerName.ADMINISTRATION_REDUCER, 'checks', 'Cheque', 'Checks')
    registerTableData(TableName.COMPANIES, false, ReducerName.SYSTEM_REDUCER, 'company', 'Compañía', 'Companies')
    registerTableData(TableName.CREDIT_CARDS, true, ReducerName.ADMINISTRATION_REDUCER, 'creditCards', 'Tarjeta', 'CreditCards')
    registerTableData(TableName.CREDIT_PAYMENTS, true, ReducerName.ADMINISTRATION_REDUCER, 'creditPayments', 'Pago de Crédito', 'CreditPayments')
    registerTableData(TableName.CUSTOMERS, true, ReducerName.SALES_REDUCER, 'customers', 'Cliente', 'Customers')
    registerTableData(TableName.CUSTOMER_TYPES, true, ReducerName.SALES_REDUCER, 'customerTypes', 'Lista de Precios', 'CustomerTypes')
    registerTableData(TableName.DELIVERIES2, true, ReducerName.DELIVERIES_REDUCER, 'deliveries', 'Entrega', 'Deliveries2')
    registerTableData(TableName.DELIVERY_ORDERS, true, ReducerName.DELIVERIES_REDUCER, 'deliveryOrders', 'Orden de Entrega', 'DeliveryOrders')
    registerTableData(TableName.DELIVERY_ROADMAPS, true, ReducerName.LOGISTICS_REDUCER, 'deliveryRoadmaps', 'Hoja de Ruta de Entrega', 'DeliveryRoadmaps')
    registerTableData(TableName.DRIVERS, true, ReducerName.LOGISTICS_REDUCER, 'drivers', 'Conductores', 'Drivers')
    registerTableData(TableName.EMPLOYEES, true, ReducerName.ADMINISTRATION_REDUCER, 'employees', 'Empleado', 'Employees')
    registerTableData(TableName.EXPENSE_TYPES, true, ReducerName.ADMINISTRATION_REDUCER, 'expenseTypes', 'Tipo de Gasto', 'ExpenseTypes')
    registerTableData(TableName.EXPENSES, true, ReducerName.ADMINISTRATION_REDUCER, 'expenses', 'Gasto', 'Expenses')
    registerTableData(TableName.FISCAL_DOCUMENTS, true, ReducerName.ADMINISTRATION_REDUCER, 'fiscalDocuments', 'Documento Fiscal', 'FiscalDocuments')
    registerTableData(TableName.HOARD_ORDERS, true, ReducerName.SALES_REDUCER, 'hoards', 'Acopio', 'HoardOrders')
    registerTableData(TableName.LOTS, true, ReducerName.PRODUCTS_REDUCER, 'lots', 'Partida', 'Lots')
    registerTableData(TableName.PAYMENT_ORDERS, true, ReducerName.ADMINISTRATION_REDUCER, 'paymentOrders', 'Orden de Pago', 'PaymentOrders')
    registerTableData(TableName.PAYMENT_TYPES, true, ReducerName.ADMINISTRATION_REDUCER, 'paymentTypes', 'Medio de Pago', 'PaymentTypes')
    registerTableData(TableName.PRODUCTS, true, ReducerName.PRODUCTS_REDUCER, 'products', 'Producto', 'Products')
    registerTableData(TableName.PRODUCT_PRICES, true, ReducerName.PRODUCTS_REDUCER, 'productPrices', '', 'ProductPrices')
    registerTableData(TableName.PURCHASE_ORDERS, true, ReducerName.PURCHASES_REDUCER, 'purchases', 'Compra', 'PurchaseOrders')
    registerTableData(TableName.REQUESTS, true, ReducerName.SYSTEM_REDUCER, 'requests', 'Solicitud de Acceso', 'Requests')
    registerTableData(TableName.ROADMAPS, true, ReducerName.LOGISTICS_REDUCER, 'roadmaps', 'Hoja de Ruta', 'Roadmaps')
    registerTableData(TableName.SALE_ORDERS, true, ReducerName.SALES_REDUCER, 'sales', 'Venta', 'SaleOrders')
    registerTableData(TableName.SETTINGS, true, ReducerName.ADMINISTRATION_REDUCER, 'settings', 'Configuración', 'Settings')
    registerTableData(TableName.SUPPLIERS, true, ReducerName.PURCHASES_REDUCER, 'suppliers', 'Proveedor', 'Suppliers')
    registerTableData(TableName.STOCK, true, ReducerName.STOCK_REDUCER, 'stock', 'Stock', 'Stock')
    registerTableData(TableName.TAXES, true, ReducerName.ADMINISTRATION_REDUCER, 'taxes', 'Impuesto', 'Taxes')
    registerTableData(TableName.TICKETS, true, ReducerName.ADMINISTRATION_REDUCER, 'tickets', 'Factura', 'Tickets')
    registerTableData(TableName.TRANSACTIONS, true, ReducerName.ADMINISTRATION_REDUCER, 'transactions', 'Transacción', 'Transactions')
    registerTableData(TableName.UNIT_TYPES, false, ReducerName.STOCK_REDUCER, 'unitTypes', 'Unidad De Medida', 'UnitTypes')
    registerTableData(TableName.USERS, false, ReducerName.SYSTEM_REDUCER, 'user', 'Usuario', 'Users')
    registerTableData(TableName.VEHICLES, true, ReducerName.LOGISTICS_REDUCER, 'vehicles', 'Vehículo', 'Vehicles')
}

const registerTableData = (
    tableName: TableName,
    hasTKey: boolean,
    reducerName: ReducerName,
    stateName: string,
    singular: string,
    dbTableName: string
) => {
    const data = new TableData(
        tableName,
        hasTKey,
        reducerName,
        stateName,
        singular,
        dbTableName
    )
    TablesData.set(tableName, data)
}
